var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2874 14.6916C35.1427 6.16693 27.5399 0 19.0464 0C8.5399 0 0 8.40178 0 18.7235V38H7.33207V18.7235C7.33207 12.4107 12.5892 7.26515 19.0464 7.26515C24.1719 7.26515 28.8482 11.1665 30.18 16.4426C30.9775 19.6297 30.7838 22.9705 29.6457 25.6124C28.7399 27.7166 27.3152 29.1758 25.8597 29.9746L20.8968 25.0901L24.9151 21.112H11.8149L11.753 34.2983L15.7171 30.2432L23.4596 37.9463L23.8545 37.9693H23.9551C29.4212 37.9693 34.3376 33.2155 36.3817 28.4769C38.1624 24.3453 38.4877 19.4531 37.2874 14.6916Z",
    fill: "#178477"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.97e103c778860f7077cc8f20f5502f7a.svg";
export { ForwardRef as ReactComponent };